export default {
  setArticles(state, articles) {
    state.articles = articles;
  },
  setArticle(state, article) {
    state.article = article;
  },
  setCategories(state, categories) {
    state.categories = categories;
  },
  setLocations(state, locations) {
    state.locations = locations;
  },
  setSubjects(state, subjects) {
    state.subjects = subjects;
  },
  setLevels(state, levels) {
    state.levels = levels;
  },
  setPagination(state, pagination) {
    state.pagination = {
      count: pagination.count,
      next: pagination.next,
      previous: pagination.previous,
      current: state.pagination.current
        ? state.pagination.current + pagination.current
        : pagination.current
    };
  }
};
